import React from 'react';

function Container({ children }) {
  return (
    <div className='w-full mx-auto px-3  dark:bg-gray-900 text-gray-900 dark:text-gray-200'>
      {children}
    </div>
  );
}

export default Container;